<template>
  <div>
    <h6 class="mb-1">
      {{ $t('Regras Específicas de Destino') }}
    </h6>
    <b-row>
      <b-col>
        <e-button
          variant="primary"
          size="sm"
          icon="plus-circle"
          :text="$t('Adicionar regra de destino')"
          @click="openAddDestinationRuleModal"
        />
      </b-col>
    </b-row>

    <b-modal
      id="destination-rule-modal"
      :title="$t(editIndex !== null ? 'Editar Regra de Destino' : 'Nova Regra de Destino')"
      size="xl"
      scrollable
      centered
      @hide="onModalHide"
    >
      <b-container>
        <b-alert
          v-if="modalError"
          show
          variant="danger"
          class="mb-1 p-2"
        >
          {{ modalError }}
        </b-alert>

        <FormulateForm
          ref="modalTaxParameterDestinationFormRef"
          name="modalTaxParameterDestinationForm"
        >
          <b-row>
            <b-col md="6">
              <FormulateInput
                id="modal-tax-parameter-destination-state-id-ibge"
                v-model="destinationRule.stateIdIbge"
                name="modalTaxParameterDestinationStateIdIbge"
                type="vue-select"
                :options="getComboStatesIdValue"
                :label="$t('Estado (UF)')"
                validation="required"
                class="required"
                :placeholder="$t('Selecione')"
                @input="onStateChange"
              />
            </b-col>
            <b-col md="6">
              <e-city-search
                id="tax-parameter-destination-city-id-ibge"
                ref="taxParameterCityIdIbgeRef"
                v-model="destinationRule.cityIdIbge"
                name="tax-parameter-destination-city-id-ibge"
                :state-id-ibge="destinationRule.stateIdIbge"
                :disabled="!destinationRule.stateIdIbge"
                :label="$t('Município')"
                :required="!destinationRule.stateIdIbge"
              />
            </b-col>
          </b-row>

          <hr>

          <h6 class="mb-1 mt-1">
            {{ $t('CBS/IBS') }}
          </h6>
          <b-row>
            <b-col md="6">
              <FormulateInput
                id="tax-parameter-destination-st-cbs-ibs"
                v-model="destinationRule.stCbsIbsCode"
                name="tax-parameter-destination-st-cbs-ibs"
                type="vue-select"
                :options="comboCstCbsIbs"
                :label="$t('ST CBS/IBS')"
                :placeholder="$t('Selecione')"
              />
            </b-col>
            <b-col md="6">
              <FormulateInput
                id="tax-parameter-destination-fiscal-classification-cbs-ibs"
                v-model="destinationRule.fiscalClassificationCbsIbsCode"
                name="tax-parameter-destination-fiscal-classification-cbs-ibs"
                type="vue-select"
                :disabled="!destinationRule.stCbsIbsCode"
                :options="comboFiscalClassificationCbsIbs"
                :label="$t('Class. CBS/IBS')"
                :placeholder="$t('Selecione')"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col
              v-show="destinationRatesVisible"
              md="4"
            >
              <FormulateInput
                id="tax-parameter-destination-cbs-percent"
                v-model="destinationRule.cbsPercent"
                name="tax-parameter-destination-cbs-percent"
                type="text-percetage"
                currency="%"
                :precision="4"
                :label="$t('CBS %')"
                :validation="'min:0|max:1'"
                :validation-messages="{
                  ...mxGetTextPercentageValidationMessages,
                }"
              />
            </b-col>
            <b-col
              v-show="destinationRatesVisible"
              md="4"
            >
              <FormulateInput
                id="tax-parameter-destination-cbs-reduction-percent"
                v-model="destinationRule.cbsReductionPercent"
                name="tax-parameter-destination-cbs-reduction-percent"
                type="text-percetage"
                currency="%"
                :precision="4"
                :label="$t('Redução CBS %')"
                :validation="'min:0|max:1'"
                :validation-messages="{
                  ...mxGetTextPercentageValidationMessages,
                }"
              />
            </b-col>
            <b-col
              v-show="destinationRatesVisible"
              md="4"
            >
              <FormulateInput
                id="tax-parameter-destination-cbs-deferral-percent"
                v-model="destinationRule.cbsDeferralPercent"
                name="tax-parameter-destination-cbs-deferral-percent"
                type="text-percetage"
                currency="%"
                :precision="4"
                :label="$t('Dif. CBS %')"
                :validation="'min:0|max:1'"
                :validation-messages="{
                  ...mxGetTextPercentageValidationMessages,
                }"
              />
            </b-col>
          </b-row>

          <hr>

          <h6
            v-if="destinationRatesVisible"
            class="mb-1 mt-1"
          >
            {{ $t('IBS Estadual') }}
          </h6>
          <b-row v-show="destinationRatesVisible">
            <b-col md="4">
              <FormulateInput
                id="tax-parameter-destination-ibs-state-percent"
                v-model="destinationRule.ibsStatePercent"
                name="tax-parameter-destination-ibs-state-percent"
                type="text-percetage"
                currency="%"
                :precision="4"
                :label="$t('IBS UF %')"
                :validation="'min:0|max:1'"
                :validation-messages="{
                  ...mxGetTextPercentageValidationMessages,
                }"
              />
            </b-col>
            <b-col md="4">
              <FormulateInput
                id="tax-parameter-destination-ibs-state-reduction-percent"
                v-model="destinationRule.ibsStateReductionPercent"
                name="tax-parameter-destination-ibs-state-reduction-percent"
                type="text-percetage"
                currency="%"
                :precision="4"
                :label="$t('Red. IBS UF %')"
                :validation="'min:0|max:1'"
                :validation-messages="{
                  ...mxGetTextPercentageValidationMessages,
                }"
              />
            </b-col>
            <b-col md="4">
              <FormulateInput
                id="tax-parameter-destination-ibs-state-deferral-percent"
                v-model="destinationRule.ibsStateDeferralPercent"
                name="tax-parameter-destination-ibs-state-deferral-percent"
                type="text-percetage"
                currency="%"
                :precision="4"
                :label="$t('Dif. IBS UF %')"
                :validation="'min:0|max:1'"
                :validation-messages="{
                  ...mxGetTextPercentageValidationMessages,
                }"
              />
            </b-col>
          </b-row>

          <hr>

          <h6
            v-if="destinationRatesVisible"
            class="mb-1 mt-1"
          >
            {{ $t('IBS Municipal') }}
          </h6>
          <b-row v-if="destinationRatesVisible">
            <b-col md="4">
              <FormulateInput
                id="tax-parameter-destination-ibs-municipal-percent"
                v-model="destinationRule.ibsMunicipalPercent"
                name="tax-parameter-destination-ibs-municipal-percent"
                type="text-percetage"
                currency="%"
                :precision="4"
                :label="$t('IBS Mun. %')"
                :validation="'min:0|max:1'"
                :validation-messages="{
                  ...mxGetTextPercentageValidationMessages,
                }"
              />
            </b-col>
            <b-col md="4">
              <FormulateInput
                id="tax-parameter-destination-ibs-municipal-reduction-percent"
                v-model="destinationRule.ibsMunicipalReductionPercent"
                name="tax-parameter-destination-ibs-municipal-reduction-percent"
                type="text-percetage"
                currency="%"
                :precision="4"
                :label="$t('Red. IBS Mun. %')"
                :validation="'min:0|max:1'"
                :validation-messages="{
                  ...mxGetTextPercentageValidationMessages,
                }"
              />
            </b-col>
            <b-col md="4">
              <FormulateInput
                id="tax-parameter-destination-ibs-municipal-deferral-percent"
                v-model="destinationRule.ibsMunicipalDeferralPercent"
                name="tax-parameter-destination-ibs-municipal-deferral-percent"
                type="text-percetage"
                currency="%"
                :precision="4"
                :label="$t('Dif. IBS Mun. %')"
                :validation="'min:0|max:1'"
                :validation-messages="{
                  ...mxGetTextPercentageValidationMessages,
                }"
              />
            </b-col>
          </b-row>

          <template v-if="false">
            <hr>

            <h6 class="mb-1 mt-1">
              {{ $t('Imposto Seletivo (Regra de Destino)') }}
            </h6>
            <b-row>
              <b-col md="4">
                <FormulateInput
                  id="tax-parameter-destination-st-selective-tax"
                  v-model="destinationRule.stSelectiveTaxCode"
                  name="tax-parameter-destination-st-selective-tax"
                  type="vue-select"
                  :options="comboCstCbsIbs"
                  :label="$t('ST Imposto Seletivo')"
                  :placeholder="$t('Selecione')"
                />
              </b-col>
              <b-col md="5">
                <FormulateInput
                  id="tax-parameter-destination-fiscal-classification-selective-tax"
                  v-model="destinationRule.fiscalClassificationSelectiveTaxCode"
                  name="tax-parameter-destination-fiscal-classification-selective-tax"
                  :disabled="!destinationRule.stSelectiveTaxCode"
                  type="vue-select"
                  :options="comboSelectiveClassTribs"
                  :label="$t('Classificação Imposto Seletivo')"
                  :placeholder="$t('Selecione')"
                />
              </b-col>
              <b-col md="6">
                <FormulateInput
                  id="tax-parameter-destination-selective-tax-type"
                  v-model="destinationRule.selectiveTaxType"
                  name="tax-parameter-destination-selective-tax-type"
                  :disabled="true"
                  type="vue-select"
                  :options="comboSelectiveTaxTypes"
                  :label="$t('Tipo Imposto Seletivo')"
                  :placeholder="$t('Selecione')"
                />
              </b-col>
              <b-col
                v-if="false && destinationRule.selectiveTaxType === 'PERCENTAGE_BY_BASE_VALUE'"
                md="3"
              >
                <FormulateInput
                  id="tax-parameter-destination-selective-tax-percent"
                  v-model="destinationRule.selectiveTaxPercent"
                  name="tax-parameter-destination-selective-tax-percent"
                  type="text-percetage"
                  currency="%"
                  :precision="4"
                  :label="$t('% Imposto Seletivo')"
                  :validation="'required|min:0|max:1'"
                  :validation-messages="{
                    ...mxGetTextPercentageValidationMessages,
                  }"
                  :disabled="true"
                />
              </b-col>
              <b-col
                v-if="false && destinationRule.selectiveTaxType === 'PERCENTAGE_BY_UNIT'"
                md="3"
              >
                <FormulateInput
                  id="tax-parameter-destination-selective-tax-value-per-unit"
                  v-model="destinationRule.selectiveTaxValuePerUnit"
                  name="tax-parameter-destination-selective-tax-value-per-unit"
                  type="text-percetage"
                  currency="R$"
                  :precision="4"
                  :label="$t('Valor/Un. Imposto Seletivo')"
                  :validation="'required'"
                  :disabled="true"
                />
              </b-col>
            </b-row>
          </template>
        </FormulateForm>
      </b-container>

      <template #modal-footer>
        <div class="d-flex justify-content-end mt-2">
          <b-button
            variant="outline-secondary"
            class="mr-1"
            @click="$bvModal.hide('destination-rule-modal')"
          >{{ $t('Cancelar') }}</b-button>
          <b-button
            variant="primary"
            @click="saveDestinationRuleFromModal"
          >{{
            $t('Salvar')
          }}</b-button>
        </div>
      </template>
    </b-modal>

    <b-row
      v-if="fiscalTaxParameter.specificDestinationRules.length"
      class="mt-1"
    >
      <b-col cols="12">
        <b-table
          show-empty
          responsive
          striped
          class="bordered"
          :items="destinationTableItems"
          :fields="destinationFields"
        >
          <template #cell(actions)="{ item }">
            <e-grid-actions
              :show-update="true"
              :show-delete="true"
              @update="() => openEditDestinationRuleModal(item)"
              @delete="() => removeDestinationRuleHandler(item)"
            />
          </template>
        </b-table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol, BTable, BButton, BModal, BAlert, BContainer } from 'bootstrap-vue'
import { mapState, mapGetters, mapActions } from 'vuex'
import EButton from '@/views/components/EButton.vue'
import ECitySearch from '@/views/components/inputs/ECitySearch.vue'
import { formulateHelper } from '@/mixins'
import EGridActions from '@/views/components/EGridActions.vue'
import { localListFindIndex } from '@/store/utils'

const getDefaultDestinationTaxParameter = () => ({
  stateIdIbge: null,
  cityIdIbge: null,
  stCbsIbsCode: null,
  fiscalClassificationCbsIbsCode: null,
  cbsPercent: null,
  cbsReductionPercent: null,
  cbsDeferralPercent: null,
  ibsStatePercent: null,
  ibsStateReductionPercent: null,
  ibsStateDeferralPercent: null,
  ibsMunicipalPercent: null,
  ibsMunicipalReductionPercent: null,
  ibsMunicipalDeferralPercent: null,
  stSelectiveTaxCode: null,
  fiscalClassificationSelectiveTaxCode: null,
  selectiveTaxType: null,
  selectiveTaxPercent: null,
  selectiveTaxValuePerUnit: null,

  taxEnabledSelectiveTax: false,

  // campos de visualização
  stCbsIbsName: null,
  fiscalClassificationCbsIbsName: null,
  stSelectiveTaxName: null,
  fiscalClassificationSelectiveTaxName: null,
})

export default {
  name: 'FiscalTaxParameterSpecialTreatmentForm',

  components: {
    BRow,
    BCol,
    BTable,
    BButton,
    BModal,
    BAlert,
    EButton,
    ECitySearch,
    BContainer,
    EGridActions,
  },

  mixins: [formulateHelper],
  data: () => ({
    editIndex: null,
    modalError: '',
    destinationRatesVisible: true,
    destinationRule: getDefaultDestinationTaxParameter(),
  }),
  computed: {
    ...mapGetters('common/states', ['getComboStatesIdValue', 'getComboStates']),
    ...mapState('pages/invoice/fiscalTaxParameters/fiscalTaxParameterMaintain', [
      'fiscalTaxParameter',
    ]),
    ...mapGetters('pages/invoice/fiscalTaxParameters', [
      'getCitiesByState',
      'getCstCbsIbs',
      'getClassTribsByCst',
      'getSelectiveTaxTypes',
    ]),
    comboSelectiveTaxTypes() {
      return this.getSelectiveTaxTypes.map(t => ({
        value: t.value,
        label: t.label,
      }))
    },
    comboCstCbsIbs() {
      return this.getCstCbsIbs.map(c => ({
        value: c.code,
        label: `${c.code} - ${c.description}`,
      }))
    },
    comboFiscalClassificationCbsIbs() {
      const cst = this.destinationRule.stCbsIbsCode
      const list = this.getClassTribsByCst(cst)
      return list.map(c => ({ value: c.code, label: `${c.code} - ${c.description}` }))
    },
    comboSelectiveClassTribs() {
      const cst = this.destinationRule.stSelectiveTaxCode
      const list = this.getClassTribsByCst(cst)
      return list.map(c => ({ value: c.code, label: `${c.code} - ${c.description}` }))
    },
    comboCities() {
      if (!this.destinationRule.stateIdIbge) return []
      return this.getCitiesByState(this.destinationRule.stateIdIbge).map(c => ({
        value: c.idIbge,
        label: c.name,
      }))
    },
    destinationFields() {
      return [
        {
          label: this.$t('Ações'),
          key: 'actions',
          class: 'text-center',
          thStyle: { minWidth: '100px' },
        },
        {
          key: 'state',
          label: this.$t('Estado'),
        },
        {
          key: 'city',
          label: this.$t('Município'),
        },
        {
          label: this.$t('ST CBS/IBS'),
          key: 'stCbsIbsName',
          class: 'text-center',
          thStyle: { minWidth: '200px' },
        },
        {
          label: this.$t('Class. CBS/IBS'),
          key: 'fiscalClassificationCbsIbsName',
          class: 'text-center',
          thStyle: { minWidth: '500px' },
        },
        {
          label: this.$t('CBS %'),
          key: 'cbsPercent',
          class: 'text-center',
          formatter: value => this.$options.filters.percentage(value, 4),
          thStyle: { minWidth: '100px' },
        },
        {
          label: this.$t('CBS Redução %'),
          key: 'cbsReductionPercent',
          class: 'text-center',
          formatter: value => this.$options.filters.percentage(value, 4),
          thStyle: { minWidth: '100px' },
        },
        {
          label: this.$t('CBS Diferimento %'),
          key: 'cbsDeferralPercent',
          class: 'text-center',
          formatter: value => this.$options.filters.percentage(value, 4),
          thStyle: { minWidth: '100px' },
        },
        {
          label: this.$t('IBS UF %'),
          key: 'ibsStatePercent',
          class: 'text-center',
          formatter: value => this.$options.filters.percentage(value, 4),
          thStyle: { minWidth: '100px' },
        },
        {
          label: this.$t('IBS UF Redução %'),
          key: 'ibsStateReductionPercent',
          class: 'text-center',
          formatter: value => this.$options.filters.percentage(value, 4),
          thStyle: { minWidth: '100px' },
        },
        {
          label: this.$t('IBS UF Diferimento %'),
          key: 'ibsStateDeferralPercent',
          class: 'text-center',
          formatter: value => this.$options.filters.percentage(value, 4),
          thStyle: { minWidth: '100px' },
        },
        {
          label: this.$t('IBS Mun. %'),
          key: 'ibsMunicipalPercent',
          class: 'text-center',
          formatter: value => this.$options.filters.percentage(value, 4),
          thStyle: { minWidth: '100px' },
        },
        {
          label: this.$t('IBS Mun. Redução %'),
          key: 'ibsMunicipalReductionPercent',
          class: 'text-center',
          formatter: value => this.$options.filters.percentage(value, 4),
          thStyle: { minWidth: '100px' },
        },
        {
          label: this.$t('IBS Mun. Diferimento %'),
          key: 'ibsMunicipalDeferralPercent',
          class: 'text-center',
          formatter: value => this.$options.filters.percentage(value, 4),
          thStyle: { minWidth: '100px' },
        },
        {
          label: this.$t('ST Seletivo'),
          key: 'stSelectiveTaxName',
          class: 'text-center',
          thStyle: { minWidth: '200px' },
        },
        {
          label: this.$t('Class. Seletivo'),
          key: 'fiscalClassificationSelectiveTaxName',
          class: 'text-center',
          thStyle: { minWidth: '500px' },
        },
        {
          label: this.$t('Tipo Seletivo'),
          key: 'selectiveTaxType',
          class: 'text-center',
          formatter: value => (value ? this.$t(value) : '-'),
        },
        {
          label: this.$t('% Seletivo'),
          key: 'selectiveTaxPercent',
          class: 'text-center',
          formatter: value => this.$options.filters.percentage(value, 4),
          thStyle: { minWidth: '100px' },
        },
        {
          label: this.$t('Valor/Unid.'),
          key: 'selectiveTaxValuePerUnit',
          class: 'text-center',
          formatter: value => this.$options.filters.percentage(value, 4),
          thStyle: { minWidth: '100px' },
        },
      ]
    },
    destinationTableItems() {
      return this.fiscalTaxParameter.specificDestinationRules.map(r => {
        const stateObj = (this.getComboStates || []).find(s => s.idIbge === r.stateIdIbge)
        const state = stateObj ? stateObj.abreviation : r.stateIdIbge
        let city
        if (r.stateIdIbge && r.cityIdIbge) {
          // TODO ajustar pra que item na lista guarde objeto da cidade
          const list = this.getCitiesByState ? this.getCitiesByState(r.stateIdIbge) : []
          const cityObj = list.find(c => c.idIbge === r.cityIdIbge)
          city = cityObj ? cityObj.name : r.cityIdIbge
        }
        return {
          ...r,
          state,
          city,
          stCbsIbsCode: r.stCbsIbsCode,
          fiscalClassificationCbsIbsCode: r.fiscalClassificationCbsIbsCode,
          cbsPercent: r.cbsPercent,
          cbsReductionPercent: r.cbsReductionPercent,
          cbsDeferralPercent: r.cbsDeferralPercent,

          ibsStatePercent: r.ibsStatePercent,
          ibsStateReductionPercent: r.ibsStateReductionPercent,
          ibsStateDeferralPercent: r.ibsStateDeferralPercent,

          ibsMunicipalPercent: r.ibsMunicipalPercent,
          ibsMunicipalReductionPercent: r.ibsMunicipalReductionPercent,
          ibsMunicipalDeferralPercent: r.ibsMunicipalDeferralPercent,

          selectiveTaxType: r.selectiveTaxType,
          selectiveTaxPercent: r.selectiveTaxPercent,
          selectiveTaxValuePerUnit: r.selectiveTaxValuePerUnit,
          stSelectiveTaxCode: r.stSelectiveTaxCode,
          fiscalClassificationSelectiveTaxCode: r.fiscalClassificationSelectiveTaxCode,

          stCbsIbsName: r.stCbsIbsName,
          fiscalClassificationCbsIbsName: r.fiscalClassificationCbsIbsName,
          stSelectiveTaxName: r.stSelectiveTaxName,
          fiscalClassificationSelectiveTaxName: r.fiscalClassificationSelectiveTaxName,
        }
      })
    },
  },
  watch: {
    'destinationRule.fiscalClassificationCbsIbsCode': async function onDestClassChange(val) {
      if (!val) return
      try {
        const { data } = await this.$http.get(`/api/tax/tax-reform/class-trib/${val}`)
        if (data) {
          this.destinationRule.cbsReductionPercent =
            data.cbsReductionPercent ?? this.destinationRule.cbsReductionPercent
          if (data.ibsReductionPercent != null) {
            this.destinationRule.ibsStateReductionPercent = data.ibsReductionPercent
            this.destinationRule.ibsMunicipalReductionPercent = data.ibsReductionPercent
          }
        }
      } catch (e) {
        this.showError({ message: this.$t('Falha ao buscar classificação fiscal (destino)') })
      }

      try {
        const cstCode = this.destinationRule.stCbsIbsCode
        const allCsts = this.getCstCbsIbs || []
        const selected = (allCsts || []).find(x => x.code === cstCode)
        const requiresTaxation = selected && selected.requiresTaxation === true
        if (!requiresTaxation) {
          this.destinationRatesVisible = false
          this.destinationRule.cbsPercent = 0
          this.destinationRule.cbsReductionPercent = 0
          this.destinationRule.cbsDeferralPercent = 0
          this.destinationRule.ibsStatePercent = 0
          this.destinationRule.ibsStateReductionPercent = 0
          this.destinationRule.ibsStateDeferralPercent = 0
          this.destinationRule.ibsMunicipalPercent = 0
          this.destinationRule.ibsMunicipalReductionPercent = 0
          this.destinationRule.ibsMunicipalDeferralPercent = 0
          return
        }
        this.destinationRatesVisible = true
      } catch (e) {
        this.destinationRatesVisible = true
      }

      try {
        const params = {
          stateIdIbge: this.destinationRule.stateIdIbge,
          cityIdIbge: this.destinationRule.cityIdIbge,
        }
        const { data: rates } = await this.$http.get('/api/tax/tax-reform/rates', { params })
        if (rates) {
          this.destinationRule.cbsPercent = rates.cbsRatePercent
          this.destinationRule.ibsStatePercent =
            rates.effectiveIbsStateRatePercent ?? rates.ibsStateDefaultRatePercent
          this.destinationRule.ibsMunicipalPercent =
            rates.effectiveIbsMunicipalRatePercent ?? rates.ibsMunicipalDefaultRatePercent
        }
      } catch (e) {
        this.showError({ message: this.$t('Falha ao buscar alíquotas vigentes (destino)') })
      }
    },

    'destinationRule.stCbsIbsCode': function destinationRuleStCbsIbs(val, oldVal) {
      if (val !== oldVal) {
        this.destinationRule.fiscalClassificationCbsIbsCode = null
      }
      if (val) {
        Promise.resolve(this.fetchClassTribsByCst(val)).catch(err => {
          this.showError({
            title: this.$t('Falha ao carregar classificações (CBS/IBS)'),
            error: err,
          })
        })
      }
    },
    'destinationRule.stSelectiveTaxCode': function destinationRuleStSelectiveTax(val, oldVal) {
      if (val !== oldVal) {
        this.destinationRule.fiscalClassificationSelectiveTaxCode = null
      }
      if (val) {
        Promise.resolve(this.fetchClassTribsByCst(val)).catch(err => {
          this.showError({
            title: this.$t('Falha ao carregar classificações (Seletivo)'),
            error: err,
          })
        })
      }
    },
    'destinationRule.selectiveTaxType': function destinationRuleSelectiveTaxType(val) {
      if (val === 'PERCENTAGE_BY_BASE_VALUE') {
        this.destinationRule.selectiveTaxValuePerUnit = null
      } else if (val === 'PERCENTAGE_BY_UNIT') {
        this.destinationRule.selectiveTaxPercent = null
      }
    },
  },
  mounted() {
    this.fetchCombos()
    this.fetchStates()
  },
  methods: {
    ...mapActions('common/states', ['fetchStates']),
    ...mapActions('pages/invoice/fiscalTaxParameters', [
      'fetchCombos',
      'fetchCitiesByState',
      'fetchClassTribsByCst',
    ]),
    ...mapActions('pages/invoice/fiscalTaxParameters/fiscalTaxParameterMaintain', [
      'addDestinationRule',
      'updateDestinationRule',
      'removeDestinationRule',
    ]),
    onStateChange() {
      this.destinationRule.cityIdIbge = null
      if (this.destinationRule.stateIdIbge && this.$refs.taxParameterCityIdIbgeRef?.reset) {
        this.$refs.taxParameterCityIdIbgeRef.reset()
      }
    },
    openAddDestinationRuleModal() {
      this.editIndex = null
      this.resetDestinationRule()
      this.$bvModal.show('destination-rule-modal')
    },
    openEditDestinationRuleModal(item) {
      const itemIndex = localListFindIndex(this.fiscalTaxParameter.specificDestinationRules, item)
      this.destinationRule = { ...this.fiscalTaxParameter.specificDestinationRules[itemIndex] }

      if (this.destinationRule.stateIdIbge) {
        this.fetchCitiesByState(this.destinationRule.stateIdIbge)
      }
      if (this.destinationRule.stCbsIbsCode) {
        Promise.resolve(this.fetchClassTribsByCst(this.destinationRule.stCbsIbsCode)).catch(
          err => {
            this.showError({
              title: this.$t('Falha ao carregar classificações (CBS/IBS)'),
              error: err,
            })
          }
        )
      }
      if (this.destinationRule.stSelectiveTaxCode) {
        Promise.resolve(this.fetchClassTribsByCst(this.destinationRule.stSelectiveTaxCode)).catch(
          err => {
            this.showError({
              title: this.$t('Falha ao carregar classificações (Seletivo)'),
              error: err,
            })
          }
        )
      }
      this.$bvModal.show('destination-rule-modal')
    },

    async saveDestinationRuleFromModal() {
      this.modalError = ''

      if (await this.$refs.modalTaxParameterDestinationFormRef.hasValidationErrors()) {
        this.$refs.modalTaxParameterDestinationFormRef.showErrors()
        this.showInvalidDataMessage()

        if (!this.destinationRule.stateIdIbge && !this.destinationRule.cityIdIbge) {
          this.modalError = this.$t('Informe Estado ou Município para a regra.')
        }
        return
      }

      const enriched = {
        ...this.destinationRule,
        stateIdIbge: this.destinationRule.stateIdIbge,
        cityIdIbge: this.destinationRule.cityIdIbge,
        stCbsIbsCode: this.destinationRule.stCbsIbsCode,
        fiscalClassificationCbsIbsCode: this.destinationRule.fiscalClassificationCbsIbsCode,
        cbsPercent: this.destinationRule.cbsPercent,
        cbsReductionPercent: this.destinationRule.cbsReductionPercent,
        cbsDeferralPercent: this.destinationRule.cbsDeferralPercent,
        ibsStatePercent: this.destinationRule.ibsStatePercent,
        ibsStateReductionPercent: this.destinationRule.ibsStateReductionPercent,
        ibsStateDeferralPercent: this.destinationRule.ibsStateDeferralPercent,
        ibsMunicipalPercent: this.destinationRule.ibsMunicipalPercent,
        ibsMunicipalReductionPercent: this.destinationRule.ibsMunicipalReductionPercent,
        ibsMunicipalDeferralPercent: this.destinationRule.ibsMunicipalDeferralPercent,
        stSelectiveTaxCode: this.destinationRule.stSelectiveTaxCode,
        fiscalClassificationSelectiveTaxCode:
          this.destinationRule.fiscalClassificationSelectiveTaxCode,
        selectiveTaxType: this.destinationRule.selectiveTaxType,
        selectiveTaxPercent: this.destinationRule.selectiveTaxPercent,
        selectiveTaxValuePerUnit: this.destinationRule.selectiveTaxValuePerUnit,
      }

      enriched.fiscalClassificationCbsIbsName = this.comboFiscalClassificationCbsIbs.find(
        c => c.value === this.destinationRule.fiscalClassificationCbsIbsCode
      )?.label
      enriched.fiscalClassificationSelectiveTaxName = this.comboSelectiveClassTribs.find(
        c => c.value === this.destinationRule.fiscalClassificationSelectiveTaxCode
      )?.label
      enriched.stSelectiveTaxName = this.comboCstCbsIbs.find(
        c => c.value === this.destinationRule.stSelectiveTaxCode
      )?.label
      enriched.stCbsIbsName = this.comboCstCbsIbs.find(
        c => c.value === this.destinationRule.stCbsIbsCode
      )?.label

      const isNewItem = !(enriched.id || enriched.localId)
      if (isNewItem) {
        this.addDestinationRule(enriched)
      } else {
        this.updateDestinationRule({ index: this.editIndex, rule: enriched })
      }

      this.$bvModal.hide('destination-rule-modal')
    },

    resetDestinationRule() {
      this.destinationRule = getDefaultDestinationTaxParameter()
    },
    onModalHide() {
      this.editIndex = null
      this.resetDestinationRule()
    },
    async removeDestinationRuleHandler(item) {
      const confirm = await this.confirm()
      if (!confirm) {
        return
      }

      this.removeDestinationRule(item)
    },
  },
}
</script>
